<template>
  <div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Paso a paso para el monitoreo de atmósferas.</h1>    
            <span class="instruccion">Haz clic en el los iconos de la imagen.</span>
          </v-flex>
      <v-flex xs12 sm8 md8 mt-4 class="text-xs-center">
          <svg1-app class="animated flipInY dura-1" v-show="!$vuetify.breakpoint.xs"></svg1-app >
            <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-8-mobile.png')" alt="" v-show="$vuetify.breakpoint.xs">
      </v-flex>
      <v-flex xs12 sm7 md7 class="text-xs-left">
        <span><strong>Aspectos relevantes en el paso a paso:</strong></span>
      </v-flex>
      <v-flex xs12 sm7 md6 class="animated fadeInUp text-xs-center">
        <v-card color="transparent" flat tile height="300">
          <v-window v-model="onboarding">
            <v-window-item v-for="n in length" :key="`card-${n}`">
              <v-card class="cont_text-slider" color="transparent" flat>
                <div class="flip-item">
                  <img v-if="onboarding===0" class="animated flipInY dura-1" height="160" :src="require('../../assets/unidad2/pantalla-1-1-slider.png')"
                    alt="">
                  <v-layout justify-center class="text-xs-left">
                    <v-flex xs12 sm8 md7 class="animated fadeInUp text-xs-left">
                      <p v-if="texto[onboarding]" class="caja_texto" v-html="texto[onboarding]"></p>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card>
            </v-window-item>
          </v-window>
          <v-card-actions class="cont_buttons-slider">
            <v-item-group light v-model="onboarding" class="text-center " mandatory>
              <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                <v-btn :color="vistos[n - 1] ? '#ff9955ff' : '#28f7d1ff'" small class="item-button" :input-value="active"
                  icon @click="toggle">
                  <v-icon>mdi-record</v-icon>
                </v-btn>
              </v-item>
            </v-item-group>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
import svg from "./svg/pantalla8";
export default {
  mixins: [nextConditions],
  components: {
    "svg1-app": svg,
  },
  data() {
    return {
      length:4, 
      onboarding: 0,
      vistos:Array(4).fill(false),
      texto:[
        '<b>(Paso 1)</b>',
        'Se deberá realizar una prueba de funcionamiento y prueba de verificación (bump test) antes de la operación de los equipos <b>(Paso 4).</b>',
        'Para las áreas con dispersión geográfica en las que no sea posible realizar el monitoreo por parte de la Autoridad de Área Local (AAL) se deberá asegurar como primer control en campo el monitoreo de atmósferas, a cargo de los ejecutores y quedar definido en el análisis de riesgos. La AAL deberá validar que los equipos y personal utilizados en el monitoreo tengan calibración vigente y se encuentren autorizados respectivamente <b>(Paso 6).</b>',
        'Si la frecuencia es superior a los espacios definidos en el permiso de trabajo la Autoridad Ejecutante (AE) definirá el formato a implementar para el monitoreo en la apertura del permiso de trabajo que así lo requiera <b>(Paso 8).</b>'
      ]
    }
  },
  mounted() {
    this.$store.commit('vistosUnidad1Mod31', false)
    this.$store.commit('vistosUnidad1Mod32', false)
    this.$store.commit('vistosUnidad1Mod33', false)
    this.$store.commit('vistosUnidad1Mod34', false)
    this.$store.commit('vistosAllMod3', false)
    this.$set(this.vistos,0,true)
  },
  watch: {
    onboarding(val){
      this.$set(this.vistos,val,true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';

.icon-titulo {
  content: url('../../assets/imagenes_compartidas/icon-titulo.png');
  align-items: center;
  justify-content: start;
  width: 15px;
  height: 15px;
}

ol {
  list-style: none;
  counter-reset: my-awesome-counter;
  padding-left: 10px;
}

ol li {
  counter-increment: my-awesome-counter;
  display: flex;
  align-items: center;
  justify-content: start;

  span {
    margin: 0.5em;
    padding: 0.5em;
    border-left: 2px solid $color-complement-one;
  }
}

ol li::before {
  content: counter(my-awesome-counter) ". ";
  color: $color-primary;
  font-weight: bold;
  margin-right: 0.01em;
}

li {}

.container-module {
  text-align: left;

  p {
    margin: 0;
    padding: 0;
  }

  img {
    width: 80px;
    display: inline-block;
    vertical-align: middle;
  }

  .modulo-name {
    display: inline-block;
    vertical-align: middle;
    width: 80%;
    text-align: left;
    padding-left: 10px;
  }

  @media screen and (max-width: 500px) {
    text-align: center;

    img {
      width: 40%;
    }

    .modulo-name {
      width: 100%;
      padding-left: 0px;
    }
  }
}

.pantalla {
  @media screen and (max-width: 600px) {
    display: none;
  }
}

.mobile {
  @media screen and (min-width: 600px) {
    display: none;
  }

  @media screen and (max-width: 600px) {
    display: block;
  }
}
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 15px;
    height: 15px;
  }
}
.flip-item{
  position: relative;
  width: 100%;
  height:auto;
  padding: 10px;
  p{
    text-align: center;
  }
  .pb{
    color: $color-secondary;
    font-family: FontBase-Bold;
  }
  @media screen and (max-width: 330px) {
    img{
      width: 150px;
    }
    
  }
}
.caja_texto{
  background:#ffff;
  padding: 5px 5px 5px 5px;
}
.lista {
    text-align: justify !important;
    background: greenyellow;
}
h1 li{
  text-align: justify
}
.encabezado{
  background: #c7ee95ff; 
}
td, th {
  border: #23cad9ff 1px solid;
  font-size: 13.6px;
}
table{
text-align:center;
}
</style>